export const norm = (value, min, max)=>(value - min) / (max - min);
export const lerp = (normal, min, max)=>(max - min) * normal + min;
export const clamp = (value, min, max)=>Math.min(Math.max(value, Math.min(min, max)), Math.max(min, max));
export const map = (value, sourceMin, sourceMax, destMin, destMax)=>lerp(norm(value, sourceMin, sourceMax), destMin, destMax);
export const inRange = (value, min, max)=>value >= Math.min(min, max) && value <= Math.max(min, max);
